<template>
  <div class="layout minimal">
      <div class="cont">
          <div>
              <div class="logo-container">
                  <router-link :to="{name: 'home'}">
                      <div class="logo"></div>
                  </router-link>
              </div>
              <slot/>
          </div>
      </div>
      <slot name="after"/>
  </div>
</template>

<script>
    import Footer from "../components/Footer";

  export default {
      components: {
          Footer,
      }
  }
</script>

<style scoped lang="scss">
  @import './../styles/variables';

  .layout.minimal{

      .cont{
          display: flex;
          justify-content: center;
          align-items: center;
          color: var(--pallete_clear_text_color);
          min-height: 100vh;

          & > div{
              display: block;
          }

          .logo-container{
              padding: 1em;

              .logo{
                  display: block;
                  margin: auto;
                  height: 50px;
                  min-width: 400px;
                  width: 100%;
                  background-image: var(--img-logo);
                  background-size: contain;
                  background-repeat: no-repeat;
                  background-position: center center;

                  @media(max-width: 500px){
                      min-width: auto;
                  }
              }
          }
      }
  }
</style>
